<div class="mb-3">
  <button class="btn btn-outline-danger" (click)="deleteObsoleteMrRelated()">
    <i class="bi bi-trash" aria-hidden="true"></i> delete obsolete MR related
  </button>
</div>

<table class="table table-hover table-sm">
  <thead class="thead-light">
    <tr>
      <th scope="col">ID</th>
      <th scope="col">UID</th>
      <th scope="col">Created</th>
      <th scope="col">Responded</th>
      <th scope="col">Tool / Provider</th>
      <th scope="col">GitLab MR / FreeScout</th>
      <th scope="col">Status</th>
      <th scope="col">Actions</th>
    </tr>
  </thead>
  <tbody>
    @for (cmd of commands; track cmd.id) {
      <tr (click)="toggleExpand(cmd.id)" class="cursor-pointer">
        <td>{{ cmd.id }}</td>
        <td>{{ cmd.stracliCommandUid }}</td>
        <td>{{ cmd.created | date:'yyyy-MM-dd HH:mm:ss' }}</td>
        <td>{{ cmd.responseReceived ? (cmd.responseReceived | date:'yyyy-MM-dd HH:mm:ss') : 'Pending' }}</td>
        <td>
          @if (cmd.command) {
            <span class="badge bg-primary me-1">{{ cmd.command.tool }}</span>
            <span class="badge bg-secondary">{{ cmd.command.aiProvider }}</span>
          }
        </td>
        <td>
          @if (cmd.gitlabMrActionType) {
            <span class="badge bg-info text-dark">{{ cmd.gitlabMrActionType }}</span>
          }
          @if (cmd.gitlabMrWebUrl) {
            <a [href]="cmd.gitlabMrWebUrl" target="_blank" class="ms-1" (click)="$event.stopPropagation()">
              <i class="bi bi-box-arrow-up-right" aria-hidden="true"></i> {{ cmd.gitlabMrWebUrl }}
            </a>
          }
          @if (cmd.gitlabMrGitlabStatus) {
            <span class="badge ms-1" [ngClass]="getGitlabStatusClass(cmd.gitlabMrGitlabStatus)">GitLab: {{ cmd.gitlabMrGitlabStatus }}</span>
          }
          @if (cmd.gitlabMrStrapiStatus) {
            <span class="badge ms-1" [ngClass]="getStrapiStatusClass(cmd.gitlabMrStrapiStatus)">Strapi: {{ cmd.gitlabMrStrapiStatus }}</span>
          }
          @if (cmd.freeScoutConversationUrl) {
            <a [href]="cmd.freeScoutConversationUrl" target="_blank" class="ms-1" (click)="$event.stopPropagation()">
              <i class="bi bi-box-arrow-up-right" aria-hidden="true"></i> {{ cmd.freeScoutConversationUrl }}
            </a>
          }
        </td>
        <td>
          @if (cmd.response) {
            <span class="badge" [ngClass]="cmd.response.exitCode === 0 ? 'bg-success' : 'bg-danger'">
              Exit: {{ cmd.response.exitCode }}
            </span>
            @if (cmd.response.pushSuccess !== null) {
              <span class="badge ms-1" [ngClass]="cmd.response.pushSuccess ? 'bg-success' : 'bg-danger'">
                Push: {{ cmd.response.pushSuccess ? 'ok' : 'fail' }}
              </span>
            }
          } @else {
            <span class="badge bg-warning text-dark">Waiting</span>
          }
        </td>
        <td>
          <button class="btn btn-sm btn-outline-primary me-1" [disabled]="!cmd.command" (click)="retryCommand(cmd, $event)">
            <i class="bi bi-arrow-clockwise" aria-hidden="true"></i> Retry
          </button>
          <button class="btn btn-sm btn-outline-danger" (click)="deleteCommand(cmd.id, $event)">Delete</button>
        </td>
      </tr>
      @if (expandedId === cmd.id) {
        <tr>
          <td colspan="8" class="bg-light">
            <div class="p-3">
              @if (cmd.command) {
                <div>
                  <strong>Command:</strong>
                  <div class="mt-1 mb-2">
                    <span class="badge bg-primary me-1">{{ cmd.command.tool }}</span>
                    <span class="badge bg-secondary me-1">{{ cmd.command.aiProvider }}</span>
                    @if (cmd.command.cloneUrl) {
                      <span class="badge bg-info text-dark me-1">clone: {{ cmd.command.cloneUrl }}</span>
                    }
                    @if (cmd.command.mountRepoReadonly) {
                      <span class="badge bg-warning text-dark me-1">repo: read-only</span>
                    }
                    @if (cmd.command.pushChanges) {
                      <span class="badge bg-warning text-dark me-1">push changes</span>
                    }
                    @if (cmd.command.forcePush) {
                      <span class="badge bg-danger me-1">force push</span>
                    }
                  </div>
                  @if (cmd.command.checkoutCommands) {
                    <div class="mb-2">
                      <strong>Checkout commands:</strong>
                      <pre class="mt-1">{{ cmd.command.checkoutCommands }}</pre>
                    </div>
                  }
                  @if (cmd.command.pushChangesBranch) {
                    <div class="mb-1">
                      <strong>Push branch:</strong> {{ cmd.command.pushChangesBranch }}
                    </div>
                  }
                  @if (cmd.command.pushChangesCommitMessage) {
                    <div class="mb-1">
                      <strong>Commit message:</strong> {{ cmd.command.pushChangesCommitMessage }}
                    </div>
                  }
                  @if (cmd.command.pushChangesName || cmd.command.pushChangesEmail) {
                    <div class="mb-1">
                      <strong>Author:</strong> {{ cmd.command.pushChangesName }} &lt;{{ cmd.command.pushChangesEmail }}&gt;
                    </div>
                  }
                  <div class="mt-2">
                    <strong>stdin:</strong>
                    <pre class="mt-1">{{ cmd.command.stdin }}</pre>
                  </div>
                </div>
              }
              @if (cmd.response) {
                <div class="mt-3">
                  <strong>Response:</strong>
                  <div class="row mt-2">
                    <div class="col-md-6">
                      <h6>stdout:</h6>
                      <pre class="small">{{ cmd.response.stdout || '(empty)' }}</pre>
                    </div>
                    <div class="col-md-6">
                      <h6>stderr:</h6>
                      <pre class="small text-danger">{{ cmd.response.stderr || '(empty)' }}</pre>
                    </div>
                  </div>
                  <div class="mt-2">
                    <small>Terminated on its own: {{ cmd.response.terminatedOnItsOwn }}</small>
                  </div>
                  @if (cmd.response.gitStatus) {
                    <div class="mt-3">
                      <h6>git status:</h6>
                      <pre class="small">{{ cmd.response.gitStatus }}</pre>
                    </div>
                  }
                  @if (cmd.response.gitDiff) {
                    <div class="mt-3">
                      <h6>git diff:</h6>
                      <pre class="small">{{ cmd.response.gitDiff }}</pre>
                    </div>
                  }
                  @if (cmd.response.pushSuccess !== null) {
                    <div class="mt-2">
                      <small>Push success: {{ cmd.response.pushSuccess }}</small>
                    </div>
                  }
                </div>
              } @else {
                <div class="text-muted">
                  No response received yet.
                </div>
              }
            </div>
          </td>
        </tr>
      }
    }
  </tbody>
</table>
